// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_OWNER,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    FOURTH_STEP,
} = require('constants/index');

const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');

class HireCardOpenYoungStep4 extends React.Component {

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            immAccounts.getIn(['byId', accountId, 'interventionType']) === ACCOUNT_INTERVENTION_OWNER
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAssociatedAccountChange,
            immAccounts,
            immHireCardOpenYoung,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep4 = immHireCardOpenYoung.getIn(['steps', FOURTH_STEP]);
        const accountErrorMsgVisible = immStep4.get('accountIsDirty') && !immStep4.get('accountIsValid');
        const accountErrorMsg = formatText('hireCardOpenYoung-hireCardOpenYoung_step4SelectAccountError');
        const accountLabel = formatText('hireCardOpenYoung-hireCardOpenYoung_step4SelectAccount');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const hasOnlyOneAccount = immAccounts.get('byId').size === 1;
        let initialAccountId;

        if (hasOnlyOneAccount) {
            initialAccountId = immAccounts.get('byOrder').first();
        }

        return (
            <article className="hire-card-open-young-step-four">
                <FormattedText
                    className="hire-card-open-young__step-title"
                    value="hireCardOpenYoung-hireCardOpenYoung_step4Title"
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep4.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    enabled={!hasOnlyOneAccount}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    initialAccountId={initialAccountId}
                    label={accountLabel}
                    onAccountChange={handleAssociatedAccountChange}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
            </article>
        );
    }
}

HireCardOpenYoungStep4.propTypes = {
    handleAssociatedAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
};

module.exports = HireCardOpenYoungStep4;
